import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Gastos" },
  { label: "Gastos", icon: "fas fa-receipt", color: "#10b981", bg: "#f0fdf4", href: "/Gastos", desc: "Registro de gastos", perm: "menu_gastos" },
  { type: "section", label: "Catálogos" },
  { label: "Categorias", icon: "far fa-list-alt", color: "#3b82f6", bg: "#eff6ff", href: "/Categorias", desc: "Categorías de gasto", perm: "menu_gastos" },
  { label: "SubCategorias", icon: "fas fa-list-ol", color: "#f59e0b", bg: "#fffbeb", href: "/SubCategorias", desc: "Subcategorías de gasto", perm: "menu_gastos" },
  { label: "Solicitantes", icon: "fas fa-user", color: "#8b5cf6", bg: "#f5f3ff", href: "/Solicitantes", desc: "Solicitantes de gasto", perm: "menu_gastos" },
];

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-wallet" color="#f59e0b" bg="#fffbeb" title="Gastos" subtitle="Registro y clasificación de gastos" />
        {user.menu_admin ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesGastos;
